"use client";

import { useAtom, useSetAtom, useAtomValue } from "jotai";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "./ui/select";
import { useNavigate, useSearchParams, useLocation } from "@remix-run/react";
import {
	regionAtom,
	regionModalAtom,
	allowedRegionAtom,
} from "~/lib/jotai/region";
import { isSingleRegionMode, Regions } from "~/models/region";
import { Region, RegionCode } from "~/types";
import { LocalStorageKey } from "~/classes/literals";
import { useEffect, useState } from "react";
import { SmallLoadingIndicator } from "./loading-indicator";
import { isLoadingAtom } from "~/lib/jotai/loading";
import { getItemWithExpiry, setItemWithExpiry } from "~/lib/utils";
import { REGION_TTL } from "~/models/generalConstants";
export const RegionSelector = () => {
	const navigate = useNavigate();
	const [region, setRegion] = useAtom(regionAtom);
	const [loading, setLoading] = useState(true);
	const setPageLoading = useSetAtom(isLoadingAtom);
	const setShowRegionModal = useSetAtom(regionModalAtom);
	const [searchParams] = useSearchParams();
	const location = useLocation();
	const u = searchParams.get("u");

	// Get allowed region from atom
	const allowedRegion = useAtomValue(allowedRegionAtom);

	useEffect(() => {
		const storedCountry = getItemWithExpiry(LocalStorageKey.Country, () =>
			setShowRegionModal(true)
		);
		if (storedCountry !== null && storedCountry in Regions) {
			const country = storedCountry as Region;
			setRegion(Regions[country].code);
		}

		setLoading(false);
	}, []);

	return (
		<>
			{loading ? (
				<SmallLoadingIndicator />
			) : (
				<Select
					disabled={isSingleRegionMode(allowedRegion)}
					value={region}
					onValueChange={(value: RegionCode) => {
						if (location.pathname != "/") setPageLoading(true);

						setRegion(value);

						if (value === Regions.Barbados.code)
							setItemWithExpiry(
								LocalStorageKey.Country,
								Regions.Barbados.name,
								REGION_TTL
							);
						else if (value === Regions.Jamaica.code)
							setItemWithExpiry(
								LocalStorageKey.Country,
								Regions.Jamaica.name,
								REGION_TTL
							);

						if (u) navigate(`/?u=${u}`);
						else navigate("/");
					}}>
					<SelectTrigger
						aria-label="Select Region"
						className="w-[100px] min-[450px]:w-[180px] py-6 border-none hover:bg-slate-100">
						<SelectValue />
					</SelectTrigger>
					<SelectContent>
						<SelectItem value={Regions.Barbados.code}>
							<div className="flex gap-2 items-center">
								<div className="flex items-center">
									<img
										src="/bb-flag-icon.png"
										alt=""
										className="w-12 h-8 object-cover"
									/>
								</div>
								<p className="font-medium sr-only min-[450px]:not-sr-only">
									{Regions.Barbados.name}
								</p>
							</div>
						</SelectItem>

						<SelectItem value={Regions.Jamaica.code}>
							<div className="flex gap-2 items-center">
								<div className="flex items-center">
									<img
										src="/jm-flag-icon.png"
										alt=""
										className="w-12 h-8 object-cover"
									/>
								</div>
								<p className="font-medium sr-only min-[450px]:not-sr-only">
									{Regions.Jamaica.name}
								</p>
							</div>
						</SelectItem>
					</SelectContent>
				</Select>
			)}
		</>
	);
};
